import React from 'react';
import { TouchableOpacity, Text, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { logout } from '@/services/auth/tokenStore';
import { router } from 'expo-router';

export function LogoutButton() {
  const handleLogout = async () => {
    await logout();
  };

  return (
    <TouchableOpacity style={styles.button} onPress={handleLogout}>
      <Text style={styles.text}>Logout</Text>
      <Ionicons name="log-out" size={20} color="#E53935" />
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: '#FFCDD2',
    backgroundColor: '#FFEBEE',
    paddingVertical: 12,
    borderRadius: 8,
    marginTop: 10,
  },
  text: {
    color: '#E53935',
    fontSize: 16,
    fontWeight: '600',
    marginRight: 8,
  },
});
